export default "__VITE_ASSET__BdnhtGhH__"